<script setup>
  import { provide, ref } from 'vue'
  import { RouterView } from 'vue-router'
  import TextDialog from '@/components/TextDialog.vue'
  import { testAppData } from '@/testdata/testdata'
  import TextDialogState from '@/components/TextDialogState.vue'

  const appData = ref(null)

  const apiRequestAppData = async tenantId => {
    appData.value = testAppData
    // TODO:
    //   const response = await apiRequest.value.request(tenantId, 'getUidReq', null)
    //   if (response.status === 200) {
    //     if (response.data.Type == "BadSession") {
    //       await logout(tenantId)
    //       appData.value = null
    //     } else {
    //       appData.value = response.data
    //     }
    //   } else {
    //     // 情報が取得出来ない時はログイン画面に戻す
    //     await logout(tenantId)
    //     appData.value = null
    //   }
  }
  provide('appData', { data: appData, refresh: apiRequestAppData })
</script>

<template>
  <RouterView />

  <TextDialogState></TextDialogState>
</template>
